import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import conciergeApiClient from 'Services/Apis/Concierge/conciergeApiClient';
import axios from 'axios';

export const postSolicitationCreateThunk = createAsyncThunk(
    `SolicitationCreateSlicer/getSolicitationCreateThunk`,
    async ({isBillPayment = false, redemptionSolicitation}, { getState, rejectWithValue }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
            'Content-Type': 'application/json'
        };

        const reqUrl = isBillPayment ? "Redemption/bill-payment" : "Redemption"

        try {
            const { data } = await conciergeApiClient.post(reqUrl, redemptionSolicitation, { headers });

            return data;
        } catch (err) {
            if (err.response) return rejectWithValue(err.response);
        }
    }
);

const initialState = {
    dataSolicitationCreate: null,
    loadingSolicitationCreate: false,
    errorSolicitationCreate: false,
};

const SolicitationCreateSlicer = createSlice({
    name: 'SolicitationCreate',
    initialState,
    reducers: {
        resetDataSolicitationCreate: (state) => {
            state.dataSolicitationCreate = null;
            state.loadingSolicitationCreate = false;
            state.errorSolicitationCreate = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(postSolicitationCreateThunk.pending, (state) => {
            state.dataSolicitationCreate = null;
            state.loadingSolicitationCreate = true;
            state.errorSolicitationCreate = false;
        });
        builder.addCase(postSolicitationCreateThunk.fulfilled, (state, action) => {
            state.dataSolicitationCreate = action.payload;
            state.loadingSolicitationCreate = false;
            state.errorSolicitationCreate = false;
        });
        builder.addCase(postSolicitationCreateThunk.rejected, (state, action) => {
            state.dataSolicitationCreate = null;
            state.loadingSolicitationCreate = false;
            state.errorSolicitationCreate = action.payload;
        });
    },
});

export const { resetDataSolicitationCreate } = SolicitationCreateSlicer.actions;
export default SolicitationCreateSlicer.reducer;